import React, { useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../../../../Atoms';
import { DateRangeContext } from '../../../index.context';
import { maxYear, minYear } from '../../../index.constants';
import * as S from './index.styles';

export const Years = ({ year, onChangeYear }) => {
    const { dispatch } = useContext(DateRangeContext);

    const years = useMemo(() => {
        const totalYears = maxYear - minYear + 1;
        return Array.from({ length: totalYears }).map((value, i) => maxYear - i);
    }, []);

    const [openItems, setOpenItems] = useState(false);
    const getItems = () => (
        <S.StyledItems>
            {years.map(y => (
                <S.StyledItem key={y} onClick={() => dispatch({ type: onChangeYear, year: y })}>
                    {y}
                </S.StyledItem>
            ))}
        </S.StyledItems>
    );

    return (
        <S.StyledCalendarSlider>
            <S.StyledSelect onClick={() => setOpenItems(!openItems)}>
                {year}
                {openItems ? (
                    <Icon padLeft icon={['far', 'chevron-up']} />
                ) : (
                    <Icon padLeft icon={['far', 'chevron-down']} />
                )}

                {openItems && getItems()}
            </S.StyledSelect>
        </S.StyledCalendarSlider>
    );
};

Years.propTypes = {
    year: PropTypes.number || PropTypes.string,
    onChangeYear: PropTypes.string,
};

/* istanbul ignore next */
Years.defaultProps = {
    year: '',
    onChangeYear: '',
};
